import RecentEarnings from '@/services/recentEarnings';

const state = {
    recentEarnings: { yesterdayEarnings: {}, sevenDaysEarnings: {} },
    userProfile: {},
    loading: false,
};

const getters = {
    getRecentEarnings: state => state.recentEarnings,
    getUserProfile: state => state.userProfile,
    getLoading: state => state.loading,
};

const actions = {
    async fetchRecentEarnings({ commit }) {
        commit('setLoading', true);
        const response = await RecentEarnings.getAll();
        commit('setRecentEarnings', response.data.earnings);
        commit('setUserProfile', response.data.userProfile);
        commit('setLoading', false);
    },
};

const mutations = {
    setRecentEarnings: (state, recentEarnings) =>
        (state.recentEarnings = recentEarnings),
    setUserProfile: (state, recentEarnings) =>
        (state.userProfile = recentEarnings),
    setLoading: (state, loading) => (state.loading = loading),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
